export default __webpack_public_path__ + "static/media/banner_left_ball.9cb8022b.mp4";